import MisVacaciones from './mis-vacaciones.vue';
import Error403 from './../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import PermisosVacaciones from './permisos.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';

// La pantalla es **para todo el personal**: cualquiera que trabaje aquí tiene vacaciones y tiene
// que poder ver las suyas. El control de acceso de verdad es la entrada de menú —que el lote
// `fase-rh-mis-vacaciones-2026-10` da de alta para todos los roles menos CLIENTE— y el backend,
// que solo exige estar identificado y devuelve siempre lo de quien pregunta.
//
// La lista de roles de respaldo vive en `permisos.js` y no aquí: la necesita también el botón
// VACACIONES del calendario, que se pinta si y solo si esta ruta es alcanzable (§9). Escrita en
// dos sitios, el botón y la ruta podrían contestar cosas distintas.
//
// Entra por `conUsuarioActualizado` —la barrera de las pantallas que deciden algo con el menú o
// con los roles— y no por el resolvedor síncrono, porque este decide con lo que haya en ese
// instante: en una recarga con la sesión guardada, `app.vue#startSession` refresca `Usuario.me()`
// de forma asíncrona y `Utils.getMenu()` contesta al momento con el menú de la sesión ANTERIOR, así
// que a quien le acaban de quitar la entrada de vacaciones se le montaba la pantalla igual —y sus
// endpoints le contestarían con lo suyo— mientras que, al revés, a quien se le acaba de dar de alta
// con el lote de despliegue le salía un 403 en su primer arranque. Con la barrera no hay un
// «después» que corregir, porque la pantalla no se monta hasta que se sabe quién mira. El porqué
// largo, en `barreraUsuarioActualizado.js` (revisión CODEX del PR #1733, ronda 8).
const routes = [
    {
        path: '/vacaciones/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: conUsuarioActualizado(function() {
            // La misma pregunta que dibuja el punto de entrada, con los mismos argumentos: el botón
            // del calendario y la pantalla no pueden contestar cosas distintas.
            if (!PermisosVacaciones.abrirMisVacaciones()) {
                return { component: Error403 };
            }
            // Y «puede registrar en nombre de otra persona» (#70) se resuelve AQUÍ y viaja como
            // `prop`, en vez de que la pantalla lo pregunte al pintarse: misma razón que la línea
            // de arriba —la barrera ya garantiza que se decide con el usuario de ahora— y mismo
            // criterio que el enlace a la ficha del Mapa de aprobación (#65).
            return {
                component: MisVacaciones,
                props: { puedeRegistrarEnNombreDe: PermisosVacaciones.registrarEnNombreDe() }
            };
        }),
        // La pantalla se conserva entre navegaciones: es la de uso diario y volver a ella no tiene
        // por qué costar otra carga del saldo. A cambio, **sobrevive al cierre de sesión y a salir
        // de ella**: la instancia es la misma si se entra con otra cuenta en la misma pestaña, y lo
        // que tuviera en memoria —el saldo, las solicitudes y la bandeja del equipo— es de la
        // anterior. Eso lo resuelve la pantalla, por `soloMandaLaDeDelante`, y no un
        // `keepAlive: false`: apagarlo haría perder el saldo cada vez que se sale al calendario,
        // que es lo que esta pantalla hace a todas horas, para arreglar algo que pasa una vez al día.
        keepAlive: true
    }
];
export default routes;
